export default "__VITE_ASSET__gyY8M15q__"